import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import messages from "./messagesSlice";
import reports from "./reportsSlice";
import users from "./usersSlice";

const reducer = combineReducers({ users, messages, reports });

const store = configureStore({
  reducer,
  //devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof reducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
